export const endpointPath = '/departments'
export interface DepartmentDto {
  id?: number;
  nameEn: string;
  namePl?: string;
  isGlobal: boolean;
  departmentAdGroupId?: string;
}
